import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Cart } from '../../shared/interface/cart.interface';
import { Values } from '../../shared/interface/setting.interface';
import { Option } from '../../shared/interface/theme-option.interface';
import { CartState } from '../../shared/store/state/cart.state';
import { SettingState } from '../../shared/store/state/setting.state';
import { ThemeOptionState } from '../../shared/store/state/theme-option.state';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { LoginWithNumberComponent } from './login-with-number/login-with-number.component';
import { TranslateModule } from '@ngx-translate/core';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { OtpComponent } from './otp/otp.component';
import { UpdatePasswordComponent } from './update-password/update-password.component';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [
    CommonModule, 
    TranslateModule, 
    FormsModule, 
    ReactiveFormsModule, 
    LoginComponent,
    ForgotPasswordComponent, 
    OtpComponent, 
    UpdatePasswordComponent, 
    RegisterComponent, 
    LoginWithNumberComponent
  ],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss'
})
export class AuthComponent {


    @Select(CartState.cartItems) cartItem$: Observable<Cart[]>;
    @Select(SettingState.setting) setting$: Observable<Values>;
    @Select(ThemeOptionState.themeOptions) themeOption$: Observable<Option>;
  
    public validate: boolean = false;
    public loginForm: FormGroup;
    public closeResult: string;
    public modalOpen: boolean = false;
    public activeForm: string = 'login';
    public storageURL = environment.storageURL;
    public themeOption: Option;

  constructor() {
    this.themeOption$.subscribe(res => this.themeOption = res);
  }

  nextForm(action: string) {
    this.activeForm = action;
  }

}
